import { useHideNav } from '@/shared/hooks/useHideNav'
import { useStyles } from './styles'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { goToShop, goToStarterPackClaim } from '@/app/routing/events'
import { useCallback, useEffect, useState } from 'react'
import { StarterPackItem } from './ui/starterPackItem'
import { TimeDisplay } from '@/shared/ui/timeDisplay'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { AppButton } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken, getUserProfileFx } from '@/entities/user'
import { $specialOfferContent, $specialOfferInfo, claimSpecialOfferFx, getSpecialOfferFx } from '@/entities/payments'
import { lang } from '@/shared/constants/lang'
import AppLoading from '@/features/loading'
import { useTimer } from '@/shared/hooks/useTimer'
import WebApp from '@twa-dev/sdk'
import { getCaseListFx } from '@/entities/cases'

export const StarterPackPage = () => {
  const { classes } = useStyles()
  const userToken = useUnit($userToken)
  const userLang = useUnit($userLanguage)
  const specialOfferInfo = useUnit($specialOfferInfo)
  const specialOfferContent = useUnit($specialOfferContent)
  const texts = lang[userLang].pages.starterPack
  const units = lang[userLang].pages.units
  const btnTexts = lang[userLang].pages.btnTexts
  const [isCreating, setIsCreating] = useState(false)
  const now = Date.now().toString()
  const { timeLeft } = useTimer(specialOfferInfo?.ends_at ?? '', now)

  useHideNav()
  const handlebb = useCallback(() => {
    goToShop({ tab: 0 })
  }, [])

  useEffect(() => {
    if (!specialOfferContent || !specialOfferInfo) {
      if (userToken) getSpecialOfferFx(userToken)
    }
  }, [userToken, specialOfferContent, specialOfferInfo])

  useBackButton({ onBack: handlebb })

  const handleClick = async () => {
    if (userToken && specialOfferInfo?.id) {
      setIsCreating(true)
      try {
        const response = await claimSpecialOfferFx({ token: userToken, offer_id: specialOfferInfo.id })

        if (response.invoice_url) {
          WebApp.openInvoice(response.invoice_url, async (status) => {
            if (status === 'paid') {
              await getUserProfileFx(userToken)
              await getCaseListFx({ token: userToken })
              goToStarterPackClaim()
            }
          })
        }
      } catch (err) {
        console.error('Ошибка при создании инвойса:', err)
      } finally {
        setIsCreating(false)
      }
    }
  }

  if (!specialOfferContent || !specialOfferInfo) return <AppLoading />
  return (
    <div className={classes.root}>
      <span className={classes.heading}>{texts.info[specialOfferInfo.name].name}</span>
      <span className={classes.description}>{texts.info[specialOfferInfo.name].description}</span>
      <div className={classes.imageWrapper}>
        <div className={classes.discountContainer} style={{ background: specialOfferInfo.discount_color }}>
          <span className={classes.discountText}>-{specialOfferInfo.discount}%</span>
        </div>
        <img src={specialOfferInfo.photo_url} alt="" className={classes.packImage} />
      </div>
      <span className={classes.packContainsText}>{texts.packContains}</span>
      <div className={classes.starterPackList}>
        {specialOfferContent.map((item) => (
          <StarterPackItem {...item} contentLength={specialOfferContent.length} />
        ))}
      </div>
      <div className={classes.timeLeftWrapper}>
        <span className={classes.expiresText}>{texts.expiresIn}</span>
        <div className={classes.timeLeftContainer}>
          <div className={classes.daysWrapper}>
            <span>
              {timeLeft.days} {units.days}
            </span>
          </div>
          <TimeDisplay
            timeLeft={timeLeft}
            styles={{
              background: 'rgba(17, 17, 17, 1)',
              boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset, 0px 1px 0px 0px rgba(72, 72, 72, 1)',
            }}
          />
        </div>
      </div>
      <ButtonWrapper style={{ width: '100%', paddingLeft: '8px', paddingRight: '8px' }}>
        <AppButton className={classes.button} onClick={handleClick} disabled={isCreating}>
          <div className={classes.openForWrapper}>
            <span>
              {btnTexts.openFor} {specialOfferInfo.discount_price}
            </span>{' '}
            <Icon view="tgStar" width={24} />
          </div>
          <div className={classes.strikethroughContainer}>
            <span>{specialOfferInfo.price}</span>
            <Icon view="tgStar" width={24} />
          </div>
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
